import { NgModule } from '@angular/core';
import { FormInputErrorPipe } from '../pipes/input-error.pipe';

@NgModule({
  declarations: [
    FormInputErrorPipe,
  ],
  exports: [FormInputErrorPipe]
})
export class InputErrorPipeModule { }